import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { data, projectData, Projectdata } from './data'; // Import your project data
import Carousel from './Carousel';
import BackButton2 from './Backbutton2';

const Table = styled.table`
  width: 80%;
  border-collapse: collapse;
  margin: 20px 0;

  td, th {
    padding: 10px;
    border: 1px solid #ddd;
    text-align: left;
  }

  th {
    background-color: #ce8e04; /* Highlight the first column */
    color: white;
    width: 30%;
  }

  tr:nth-child(even) {
    background-color: #f9f9f9;
  }

  /* Responsive adjustments */
  @media (max-width: 768px) {
    width: 100%; /* Make the table take full width on smaller screens */
    font-size: 14px; /* Slightly reduce font size */

    td, th {
      padding: 8px; /* Reduce padding on smaller screens */
    }

    th {
      width: 40%; /* Adjust column width to fit smaller screens */
    }
  }

  @media (max-width: 480px) {
    font-size: 12px; /* Further reduce font size on very small screens */

    td, th {
      padding: 6px; /* Further reduce padding */
    }

    th {
      width: 50%; /* Adjust first column width on very small screens */
    }
  }
`;


const ProjectDetails = () => {
  const [selectedImage, setSelectedImage] = useState(null); // State to store the clicked image

  // Function to handle image click
  const handleImageClick = (imgSrc) => {
    setSelectedImage(imgSrc); // Set the clicked image
  };

  // Function to close the enlarged image
  const closeImage = () => {
    setSelectedImage(null); // Reset the selected image to null
  };
  const { projectId } = useParams(); // Get the project ID from the URL
  const project = projectData.find((proj) => proj.id === parseInt(projectId)); // Find the project by ID

  // Check if project exists
  if (!project) {
    return <div>Project not found</div>;
  }

  return (
    <div>
    <div className="product-details-page">
      {/* Large Product Image */}
      <div className="product-image-container">
        <img
          src={project.image}
          alt="Product Image"
          className="product-image"
          
        /><BackButton2 />
      </div>
      </div>
    <div className='servicehelo'>
      
    <div className="services">
    <div>
      <h1>{project.name}</h1>
      <Table>
        <tbody>
          <tr>
            <th>Project Name</th>
            <td>{project.name}</td>
          </tr>
          <tr>
            <th>Location</th>
            <td>{project.location}</td>
          </tr>
          <tr>
            <th>Client</th>
            <td>{project.client}</td>
          </tr>
          <tr>
            <th>Completion Date</th>
            <td>{project.completionDate}</td>
          </tr>
          
          <tr>
            <th>Description</th>
            <td>{project.description}</td>
          </tr>
        </tbody>
      </Table>
    </div>
    <div>
    <div>
      {/* Image Gallery */}
      <div className="image-gallery">
        {project.im.map((imgSrc, index) => (
          <img 
            key={index} 
            src={imgSrc} 
            alt={`Project image ${index + 1}`} 
            onClick={() => handleImageClick(imgSrc)} // When an image is clicked
          />
        ))}
      </div>

      {/* Enlarged Image Modal */}
      {selectedImage && (
        <div className="modal">
          <div className="modal-content">
            <button className="close-button" onClick={closeImage}>X</button>
            <img src={selectedImage} alt="Enlarged project" />
          </div>
        </div>
      )}
    </div>
    </div>
      </div>
        
      </div></div>
    
  );
};

export default ProjectDetails;
